import { DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import {
  TWO_TO_THREE_LETTER_LANGUAGE_CODE,
  localeStringToLocaleKey,
} from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_LANGUAGE_CODE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getNavigator } from "@faire/web--source/common/globals/getNavigator";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";

import { getUser } from "./getUser";

export const getLocaleId = (): string | undefined => {
  return getGlobalProperty("localeId");
};

const getLocaleKey = (): ILocaleKey | undefined => {
  return getGlobalProperty("localeKey");
};

const userLocaleKey = (): ILocaleKey => {
  return (
    getUser()?.locale_key ?? getBrowserDefaultLocaleKey() ?? DEFAULT_LOCALE_KEY
  );
};

const userLocale = (): keyof typeof Language => {
  return (
    getUser()?.locale_key?.language ??
    getBrowserDefaultLanguage() ??
    DEFAULT_LOCALE_KEY.language
  );
};

const getBrowserDefaultLocaleKey = (): ILocaleKey =>
  localeStringToLocaleKey(getNavigator()?.language ?? "");

const getBrowserDefaultLanguage = (): keyof typeof Language => {
  let defaultLanguage = getWindow()?.navigator?.language?.toUpperCase() ?? "";
  if (defaultLanguage.includes("-")) {
    defaultLanguage = defaultLanguage.split("-")[0] ?? "";
  }
  return TWO_TO_THREE_LETTER_LANGUAGE_CODE[
    defaultLanguage
  ] as keyof typeof Language;
};

export const browserLevelLocaleKey = (): ILocaleKey => {
  return getLocaleKey() ?? userLocaleKey();
};

export const browserLevelLanguage = (): keyof typeof Language => {
  return getLocaleKey()?.language ?? userLocale();
};
